import { JogControl } from './JogControl';

/** A compact label, rate lever, and precise value share one aligned row. */
export function JogRangeControl({ label, detail, ...props }: Parameters<typeof JogControl>[0] & { detail?: string }) {
  return <div className="jog-range"><span>{label}{props.unit && <small className="jog-unit" aria-hidden="true"> {props.unit}</small>}{detail && <small>{detail}</small>}</span><JogControl label={label} {...props} /></div>;
}
